// extracted by mini-css-extract-plugin
export var fontBold = "peKFGazPId_hkFxuPHRy";
export var fontMedium = "ua75sZiehKk1yNjIqyOV";
export var fontRegular = "F3M880a6eE3ECRc_MeF5";
export var fontSemiBold = "HL_67lrcltEsws3_BmJw";